<template>
  <v-card>
    <v-container fluid grid-list-lg>
      <v-layout row wrap>
        <v-flex xs3>
          <v-card>
            <v-card-title primary-title>
              <div class="headline">DBO</div>
            </v-card-title>
            <v-data-table
              :headers="headers"
              :items="flights | onlyWaiting"
              :search="search"
              hide-actions
              default-sort="StartTime:desc"
              must-sort
              no-data-text="Geen DBOers"
            >
              <template v-slot:items="props">
                <td class="text-xs-left">{{ props.item.commander.name }}</td>

                <td
                  class="text-xs-left"
                  v-if="props.item.passenger !== undefined"
                >
                  {{ props.item.passenger.name }}
                </td>
                <td class="text-xs-left" v-else></td>

                <td class="text-xs-left">
                  {{ planeToString(props.item.plane) }}
                </td>
              </template>
            </v-data-table>
          </v-card>
        </v-flex>

        <v-flex xs3>
          <v-card>
            <v-card-title primary-title>
              <div class="headline">Solo</div>
            </v-card-title>
            <v-data-table
              :headers="headers"
              :items="flights | onlyFlying"
              :search="search"
              hide-actions
              default-sort="StartTime:desc"
              must-sort
              no-data-text="Geen solisten"
            >
              <template v-slot:items="props">
                <td class="text-xs-left">{{ props.item.commander.name }}</td>

                <td
                  class="text-xs-left"
                  v-if="props.item.passenger !== undefined"
                >
                  {{ props.item.passenger.name }}
                </td>
                <td class="text-xs-left" v-else></td>

                <td class="text-xs-left">
                  {{ planeToString(props.item.plane) }}
                </td>
                <td class="text-xs-left" v-if="props.item.startTime !== null">
                  {{ props.item.startTime.seconds | formatedTime }}
                </td>
                <td class="text-xs-left" v-else></td>

                <td class="text-xs-left">
                  {{ duration(props.item) | formatedDuration }}
                </td>
              </template>
            </v-data-table>
          </v-card>
        </v-flex>

        <v-flex xs3>
          <v-card>
            <v-card-title primary-title>
              <div class="headline">ZVB</div>
            </v-card-title>
            <v-data-table
              :headers="headers"
              :items="justLandedFlights"
              :search="search"
              hide-actions
              default-sort="StartTime:desc"
              must-sort
              no-data-text="Geen ZVBers"
            >
              <template v-slot:items="props">
                <td class="text-xs-left">{{ props.item.commander.name }}</td>

                <td
                  class="text-xs-left"
                  v-if="props.item.passenger !== undefined"
                >
                  {{ props.item.passenger.name }}
                </td>
                <td class="text-xs-left" v-else></td>

                <td class="text-xs-left">
                  {{ planeToString(props.item.plane) }}
                </td>
                <td class="text-xs-left" v-if="props.item.startTime !== null">
                  {{ props.item.startTime.seconds | formatedTime }}
                </td>
                <td class="text-xs-left" v-else></td>

                <td class="text-xs-left">
                  {{ duration(props.item) | formatedDuration }}
                </td>
              </template>
            </v-data-table>
          </v-card>
        </v-flex>

        <v-flex xs3>
          <v-card>
            <v-card-title primary-title>
              <div class="headline">Instructeur</div>
            </v-card-title>
            <v-data-table
              :headers="headers"
              :items="justLandedFlights"
              :search="search"
              hide-actions
              default-sort="StartTime:desc"
              must-sort
              no-data-text="Geen instructeurs"
            >
              <template v-slot:items="props">
                <td class="text-xs-left">{{ props.item.commander.name }}</td>

                <td
                  class="text-xs-left"
                  v-if="props.item.passenger !== undefined"
                >
                  {{ props.item.passenger.name }}
                </td>
                <td class="text-xs-left" v-else></td>

                <td class="text-xs-left">
                  {{ planeToString(props.item.plane) }}
                </td>
                <td class="text-xs-left" v-if="props.item.startTime !== null">
                  {{ props.item.startTime.seconds | formatedTime }}
                </td>
                <td class="text-xs-left" v-else></td>

                <td class="text-xs-left">
                  {{ duration(props.item) | formatedDuration }}
                </td>
              </template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>

<script>
import { db } from "../main";
import moment from "moment";

export default {
  data() {
    return {
      search: "",
      headers: [
        {
          text: "Naam",
          align: "left",
          sortable: true,
          value: "commander.name"
        },
        {
          text: "Aantal vluchten",
          align: "left",
          sortable: true,
          value: "passenger.name"
        }
      ],
      flights: [],
      today: null,
      now: null
    };
  },
  filters: {},
  computed: {},
  methods: {},
  firestore() {
    var today = new moment();
    this.$data.today = today.format("YYYY-MM-DD");
    return {
      flights: db
        .collection("flydays")
        .doc(this.$data.today)
        .collection("flights")
    };
  }
};
</script>
